import React, { useEffect, useRef } from "react";
import barba from "@barba/core";
import gsap from "gsap"; // Make sure GSAP is properly imported
import { useLocation } from "react-router-dom";

const BarbaWrapper = ({ camera, flags, children }) => {
  const location = useLocation();
  useEffect(() => {
    // Function to update camera position based on route
    const updateCameraPosition = () => {
      const canvasElements = Array.from(document.querySelectorAll("canvas"));
      if (canvasElements.length > 0) {
        const lastCanvas = canvasElements[canvasElements.length - 1];
        canvasElements.forEach((canvasElement) => {
          if (canvasElement !== lastCanvas) {
            canvasElement.remove();
          }
        });
      }

      // Your logic to update camera position based on route
      if (location.pathname === "/") {
        gsap.to(camera.position, {
          duration: 4,
          x: 0,
          y: 0,
          z: 17.5,
          ease: "power4.out",
        });
        flags.hasClicked = false;
        document.body.classList.remove("page-transitioned");
      } else if (
        location.pathname === "/connected-wallet" ||
        location.pathname === "/acquire-brain" ||
        location.pathname === "/burning-redeem" ||
        location.pathname === "/burning" ||
        location.pathname === "/my-inventory" ||
        location.pathname === "/staking" ||
        location.pathname === "/configure-metadata"
      ) {
        gsap.to(camera.position, {
          duration: 4,
          x: -2,
          y: 5,
          z: 12,
          ease: "power4.out",
        });
        flags.hasClicked = true;
        document.body.classList.add("page-transitioned");
      }
    };

    updateCameraPosition();
  }, [camera, flags, location.pathname]);

  return <>{children}</>;
};

export default BarbaWrapper;
